import { useState } from 'react'
import { supabase } from '../supabase'
import './ChangePasswordModal.css'

export default function ChangePasswordModal({ onClose }) {
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [loading, setLoading] = useState(false)
  const [msg, setMsg] = useState(null)

  async function handleSubmit(e) {
    e.preventDefault()
    if (password !== confirm) return setMsg({ type: 'error', text: 'Les mots de passe ne correspondent pas.' })
    if (password.length < 6) return setMsg({ type: 'error', text: 'Minimum 6 caractères.' })
    setLoading(true)
    setMsg(null)
    const { error } = await supabase.auth.updateUser({ password })
    if (error) {
      setMsg({ type: 'error', text: error.message })
    } else {
      setMsg({ type: 'success', text: 'Mot de passe mis à jour.' })
      setTimeout(onClose, 1500)
    }
    setLoading(false)
  }

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal-box">
        <div className="modal-header">
          <div>
            <h3>Changer mon mot de passe</h3>
            <p className="modal-sub">Choisissez un nouveau mot de passe sécurisé</p>
          </div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        {msg && <div className={`alert alert-${msg.type}`}>{msg.text}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nouveau mot de passe</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              minLength={6}
              placeholder="6 caractères minimum"
              autoFocus
            />
          </div>
          <div className="form-group">
            <label>Confirmer le mot de passe</label>
            <input
              type="password"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              required
              placeholder="Répétez le mot de passe"
            />
          </div>
          <div className="modal-actions">
            <button type="button" className="btn btn-outline" onClick={onClose}>Annuler</button>
            <button type="submit" className="btn btn-bordeaux" disabled={loading}>
              {loading ? 'Enregistrement...' : 'Enregistrer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
